import { Button, Icon, Input } from 'antd';
import React, { Component } from 'react';
import lang from './../../../../languages/en';
import { alertError, alertSuccess } from './../../../../services/dialog';
import history from './../../../../services/history';
import { resetPassword } from './../../../../utils/forgotPassword';
import { checkInputEmpty, checkValidatePassword } from './helper';
import './styles.css';
import { titleHead } from './../../../../services/helper'

class ResetPassword extends Component {
    constructor(props) {
        super(props)

        this.state = {
            inputs: {
                code: '',
                password: '',
                confirmPassword: '',
            },
            passwordMerge: true,
            message: {},
            isLoading: false
        }
    }

    componentDidMount() {
        titleHead("Reset Password")

        let url = window.location.href
        let code = url.split('token=')[1]
        if (!code) {
            history.push('/login')
        }
        this.setState({
            inputs: {
                ...this.state.inputs,
                code,
            },
        })
    }

    unmask = (id) => {
        let x = document.getElementById(id);
        if (x.type === "password") {
            x.type = "text";
        } else {
            x.type = "password";
        }
    }

    checkFieldEmpty = (value, name) => {
        this.setState({
            message: checkInputEmpty(value, name)
        })
    }

    onChange = (value, column) => {
        this.checkFieldEmpty(value, column)

        this.setState({
            inputs: {
                ...this.state.inputs,
                [column]: value,
            },
        })
    }

    validate = () => {
        const { password, confirmPassword } = this.state.inputs;
        let message = checkValidatePassword(password, confirmPassword)
        if (!Object.keys(message).length) return true

        this.setState({
            message
        })
        return false;
    }

    onSubmit = (e) => {
        e.preventDefault()
        if (!this.validate()) return;

        this.setState({
            isLoading: true,
        })
        let data = {
            newPassword: this.state.inputs.password,
            secretCode: this.state.inputs.code,
        }

        resetPassword(data).then(res => {
            switch (res.data.code) {
                case 10001:
                    alertSuccess(lang.password_reset_sucess)
                    history.push('/login')
                    break
                case 103004: 
                    alertError(lang.link_reset_password_invalid)
                    break;
                default:
                    alertError(lang.password_expired)
                    break
            }

            this.setState({
                isLoading: false,
            })
            return
        }).catch(err => {
            switch (err.response.data.code) {
                case 410:
                    alertError(lang.password_expired)
                    break
                case 400:
                    alertError(lang.wrong_format_password)
                    break
                default:
                    alertError(lang.link_reset_password_invalid)
                    this.props.history.push('/forgot-password')
                    break
            }
            this.setState({
                isLoading: false,
            })
            return
        })
    }

    checkButtonSubmit = () => {
        const { password, confirmPassword } = this.state.inputs
        if(!password || !confirmPassword) return true
        return false;
    }

    render() {
        const { password, confirmPassword } = this.state.inputs

        return (
            <div id="new-password">
                <div className="new-password-form">
                    <h1>Enter New Password</h1>
                    <form autoComplete="off">
                        <div className='input'>
                            <label>New password</label>
                            <Input
                                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                type="password"
                                id='password'
                                placeholder="New password"
                                onChange={e => this.onChange(e.target.value, 'password')}
                                autoComplete="off"
                                addonAfter={<span onClick={e => { this.unmask("password") }} style={{ cursor: "pointer" }} ><Icon type="eye" /></span>}
                                value={password}
                                maxLength={32}
                            />
                            <span className='message'>{this.state.message.name === 'password' && this.state.message.value}</span>
                        </div>
                        <div className='input'>
                            <label>Confirm new password</label>
                            <Input
                                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                type="password"
                                id='confirmPassword'
                                placeholder="Confirm new password"
                                onChange={e => this.onChange(e.target.value, 'confirmPassword')}
                                autoComplete="off"
                                addonAfter={<span onClick={e => { this.unmask("confirmPassword") }} style={{ cursor: "pointer" }} ><Icon type="eye" /></span>}
                                value={confirmPassword}
                                maxLength={32}
                            />
                            <span className='message'>{this.state.message.name === 'confirmPassword' && this.state.message.value}</span>
                        </div>
                        <div className="ant-form-explain password-not-merge message">
                            {this.state.message.name === 'error' && this.state.message.value}
                        </div>
                        <div className='button-submit'>
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="new-password-form-button"
                                onClick={(e) => this.onSubmit(e)}
                                disabled={this.checkButtonSubmit()}
                            >Create new password</Button>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

export default ResetPassword


// WEBPACK FOOTER //
// ./src/containers/auth/forgot-password/reset-password/index.js